import type { ServiceInput } from '../domain/entities/Service.entity';

/**
 * Real service list provided directly by the client (Daruosh) on 2026-08-10,
 * replacing the earlier 10-item invented placeholder list. This is
 * deliberately just a plain array — adding, removing, or reordering a
 * service is a one-item change here, no other code needs to change (per the
 * client's explicit "Modular" requirement).
 *
 * `image` still points at a placeholder asset path (no real service photos
 * exist yet) — same convention as the rest of the placeholder content in
 * this codebase, NOT a stock photo pretending to be a real one.
 */
export const servicesContent: ServiceInput[] = [
  {
    id: 'svc-mining-exploration',
    title: 'اکتشافات معدنی',
    slug: 'mining-exploration',
    summary: 'مطالعات و فعالیت‌های مرتبط با شناسایی، بررسی و توسعه محدوده‌های معدنی.',
    description: 'مطالعات و فعالیت‌های مرتبط با شناسایی، بررسی و توسعه محدوده‌های معدنی.',
    icon: 'compass',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'اکتشافات معدنی — داریوش معدن آذر',
      description: 'مطالعات و فعالیت‌های مرتبط با شناسایی، بررسی و توسعه محدوده‌های معدنی.'
    }
  },
  {
    id: 'svc-geology-reserve-evaluation',
    title: 'زمین‌شناسی و ارزیابی ذخایر',
    slug: 'geology-reserve-evaluation',
    summary: 'بررسی‌های زمین‌شناسی و ارزیابی پتانسیل محدوده‌های معدنی برای تصمیم‌گیری و توسعه پروژه.',
    description: 'بررسی‌های زمین‌شناسی و ارزیابی پتانسیل محدوده‌های معدنی برای تصمیم‌گیری و توسعه پروژه.',
    icon: 'flask',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'زمین‌شناسی و ارزیابی ذخایر — داریوش معدن آذر',
      description: 'بررسی‌های زمین‌شناسی و ارزیابی پتانسیل محدوده‌های معدنی.'
    }
  },
  {
    id: 'svc-mine-extraction-development',
    title: 'استخراج و توسعه معادن',
    slug: 'mine-extraction-development',
    summary: 'برنامه‌ریزی و اجرای فعالیت‌های مرتبط با استخراج و توسعه پروژه‌های معدنی.',
    description: 'برنامه‌ریزی و اجرای فعالیت‌های مرتبط با استخراج و توسعه پروژه‌های معدنی.',
    icon: 'gears',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'استخراج و توسعه معادن — داریوش معدن آذر',
      description: 'برنامه‌ریزی و اجرای فعالیت‌های مرتبط با استخراج و توسعه پروژه‌های معدنی.'
    }
  },
  {
    id: 'svc-project-development-investment',
    title: 'توسعه و سرمایه‌گذاری در پروژه‌های معدنی',
    slug: 'project-development-investment',
    summary: 'شناسایی، توسعه و مشارکت در پروژه‌های دارای پتانسیل اقتصادی در زنجیره معدن.',
    description: 'شناسایی، توسعه و مشارکت در پروژه‌های دارای پتانسیل اقتصادی در زنجیره معدن.',
    icon: 'chart-line',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'توسعه و سرمایه‌گذاری در پروژه‌های معدنی — داریوش معدن آذر',
      description: 'شناسایی، توسعه و مشارکت در پروژه‌های دارای پتانسیل اقتصادی در زنجیره معدن.'
    }
  },
  {
    id: 'svc-mineral-processing-industries',
    title: 'فرآوری و صنایع معدنی',
    slug: 'mineral-processing-industries',
    summary: 'توسعه فعالیت‌های مرتبط با فرآوری مواد معدنی و ایجاد ارزش افزوده در زنجیره معدن.',
    description: 'توسعه فعالیت‌های مرتبط با فرآوری مواد معدنی و ایجاد ارزش افزوده در زنجیره معدن.',
    icon: 'flask',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'فرآوری و صنایع معدنی — داریوش معدن آذر',
      description: 'توسعه فعالیت‌های مرتبط با فرآوری مواد معدنی و ایجاد ارزش افزوده.'
    }
  },
  {
    id: 'svc-industrial-mining-projects',
    title: 'توسعه پروژه‌های صنعتی معدنی',
    slug: 'industrial-mining-projects',
    summary:
      'توسعه زیرساخت‌ها و پروژه‌های صنعتی مرتبط با مواد معدنی؛ از جمله پروژه کارخانه ذوب سرب و روی در شهرک صنعتی شماره ۱ زاهدان.',
    description:
      'توسعه زیرساخت‌ها و پروژه‌های صنعتی مرتبط با مواد معدنی؛ از جمله پروژه کارخانه ذوب سرب و روی در شهرک صنعتی شماره ۱ زاهدان.',
    icon: 'construction',
    image: '/images/services/placeholder-service.svg',
    seo: {
      title: 'توسعه پروژه‌های صنعتی معدنی — داریوش معدن آذر',
      description: 'توسعه زیرساخت‌ها و پروژه‌های صنعتی مرتبط با مواد معدنی.'
    }
  }
];
